"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSSEvent = exports.WSCEvent = void 0;
var WSCEvent;
(function (WSCEvent) {
    WSCEvent[WSCEvent["PING"] = 0] = "PING";
    WSCEvent[WSCEvent["PONG"] = 1] = "PONG";
    WSCEvent[WSCEvent["ORGANIZATION_ONLINE_USER"] = 2] = "ORGANIZATION_ONLINE_USER";
})(WSCEvent = exports.WSCEvent || (exports.WSCEvent = {}));
var WSSEvent;
(function (WSSEvent) {
    WSSEvent[WSSEvent["PING"] = 0] = "PING";
    WSSEvent[WSSEvent["PONG"] = 1] = "PONG";
    WSSEvent[WSSEvent["SHUTDOWN"] = 2] = "SHUTDOWN";
    WSSEvent[WSSEvent["ORGANIZATION_ONLINE_USER"] = 3] = "ORGANIZATION_ONLINE_USER";
    WSSEvent[WSSEvent["ORGANIZATION_ONLINE_USER_JOIN"] = 4] = "ORGANIZATION_ONLINE_USER_JOIN";
    WSSEvent[WSSEvent["ORGANIZATION_ONLINE_USER_LEAVE"] = 5] = "ORGANIZATION_ONLINE_USER_LEAVE";
    WSSEvent[WSSEvent["ORGANIZATION_SERVICE_ADD"] = 6] = "ORGANIZATION_SERVICE_ADD";
    WSSEvent[WSSEvent["ORGANIZATION_SERVICE_MOD"] = 7] = "ORGANIZATION_SERVICE_MOD";
    WSSEvent[WSSEvent["ORGANIZATION_SERVICE_DEL"] = 8] = "ORGANIZATION_SERVICE_DEL";
    WSSEvent[WSSEvent["ORGANIZATION_EVENT_CATEGORY_ADD"] = 9] = "ORGANIZATION_EVENT_CATEGORY_ADD";
    WSSEvent[WSSEvent["ORGANIZATION_EVENT_CATEGORY_MOD"] = 10] = "ORGANIZATION_EVENT_CATEGORY_MOD";
    WSSEvent[WSSEvent["ORGANIZATION_EVENT_CATEGORY_DEL"] = 11] = "ORGANIZATION_EVENT_CATEGORY_DEL";
    WSSEvent[WSSEvent["EVENT_ADD"] = 12] = "EVENT_ADD";
    WSSEvent[WSSEvent["EVENT_MOD"] = 13] = "EVENT_MOD";
    WSSEvent[WSSEvent["EVENT_DEL"] = 14] = "EVENT_DEL";
    WSSEvent[WSSEvent["EVENT_COMMENT_ADD"] = 15] = "EVENT_COMMENT_ADD";
    WSSEvent[WSSEvent["EVENT_COMMENT_MOD"] = 16] = "EVENT_COMMENT_MOD";
    WSSEvent[WSSEvent["EVENT_COMMENT_DEL"] = 17] = "EVENT_COMMENT_DEL";
    WSSEvent[WSSEvent["GROUP_ADD"] = 18] = "GROUP_ADD";
    WSSEvent[WSSEvent["GROUP_MOD"] = 19] = "GROUP_MOD";
    WSSEvent[WSSEvent["GROUP_DEL"] = 20] = "GROUP_DEL";
    WSSEvent[WSSEvent["USER_ADD"] = 21] = "USER_ADD";
    WSSEvent[WSSEvent["USER_MOD"] = 22] = "USER_MOD";
    WSSEvent[WSSEvent["USER_DEL"] = 23] = "USER_DEL";
    WSSEvent[WSSEvent["FACILITY_TYPE_ADD"] = 24] = "FACILITY_TYPE_ADD";
    WSSEvent[WSSEvent["FACILITY_TYPE_MOD"] = 25] = "FACILITY_TYPE_MOD";
    WSSEvent[WSSEvent["FACILITY_TYPE_DEL"] = 26] = "FACILITY_TYPE_DEL";
    WSSEvent[WSSEvent["FACILITY_ADD"] = 27] = "FACILITY_ADD";
    WSSEvent[WSSEvent["FACILITY_MOD"] = 28] = "FACILITY_MOD";
    WSSEvent[WSSEvent["FACILITY_DEL"] = 29] = "FACILITY_DEL";
    WSSEvent[WSSEvent["FACILITY_CCTV_SNAPSHOT_ADD"] = 30] = "FACILITY_CCTV_SNAPSHOT_ADD";
    WSSEvent[WSSEvent["FACILITY_CCTV_SNAPSHOT_DEL"] = 31] = "FACILITY_CCTV_SNAPSHOT_DEL";
})(WSSEvent = exports.WSSEvent || (exports.WSSEvent = {}));
